import React from 'react'
import { Timeline, TimelineEvent } from 'react-event-timeline'
import { Icon, Modal, Label, Button } from 'semantic-ui-react'
import { TimeLineStepCont } from './styled'

export default class Approvers extends React.Component {
  render() {
    const { approvers, loading } = this.props
    
    return (
      <Modal
        size='tiny'
        trigger={
          <Button 
            basic  
            circular 
            type='button' 
            loading={loading} 
            content='View Approver' 
            labelPosition='right'
            icon='sort numeric down' />}
        header='GOA'
        actions={['Close']}
        content={
          approvers.length?
          <TimeLineStepCont>
            <Timeline>
              {approvers.length&&
                approvers.map((item,i,array)=>{
                  if(i!==(array.length-1)){
                    return (
                      <TimelineEvent
                        key={i} 
                        collapsible={true}
                        showContent={true}
                        title={item.stepName}
                        contentStyle={{padding:0,margin:0}}
                        bubbleStyle={{borderWidth:0,marginLeft:2}}
                        titleStyle={{fontWeight:'bold',height:'2rem',display:'flex',alignItems: 'center'}}
                        icon={<Label circular color='grey'>{i+1}</Label>}
                      >
                        <Timeline>
                          {item.approval.map((iItem,ii)=>{
                            return(
                              <TimelineEvent
                                className='tlCon'
                                key={ii} 
                                collapsible={true}
                                showContent={true}
                                title={iItem.stepName}
                                contentStyle={{padding:0,margin:0}}
                                bubbleStyle={{borderWidth:0,marginLeft:2}}
                                titleStyle={iItem.position?{fontWeight:'bold'}:{fontWeight:'bold',height:'2rem',display:'flex',alignItems: 'center'}}
                                icon={<Label circular color='grey'><Icon name='thumbtack'/></Label>}
                              >
                                {iItem.approvers.map((iiItem,iii)=>{
                                  return(
                                    <TimelineEvent 
                                      key={iii} 
                                      collapsible={true}
                                      showContent={true}
                                      title={<div className='displayName'><div>{iiItem.displayName}</div><div>{`${iiItem.position?`(${iiItem.position})`:''}`}</div></div>}
                                      bubbleStyle={{borderWidth:0,marginLeft:2}}
                                      titleStyle={iiItem.position?{fontWeight:'bold'}:{fontWeight:'bold',height:'2rem',display:'flex',alignItems: 'center'}}
                                      icon={<Label circular color='grey'><Icon name='user'/></Label>}
                                    />
                                  )
                                })}
                              </TimelineEvent>
                            )
                          })}
                        </Timeline>
                      </TimelineEvent>
                    )
                  }else{
                    return (
                      <TimelineEvent 
                        title='Complete'
                        createdAt=""
                        bubbleStyle={{borderWidth:0,marginLeft:2}}
                        titleStyle={{fontWeight:'bold',height:'2rem',display:'flex',alignItems: 'center'}}
                        icon={<Label circular color='grey'>{i+1}</Label>}
                      />
                    )
                  }
                })
              }
            </Timeline>
          </TimeLineStepCont>:'Not found'
        }
      />
    )
  }
}
